import script from "./fw25_admin.vue?vue&type=script&setup=true&lang=js"
export * from "./fw25_admin.vue?vue&type=script&setup=true&lang=js"

import "./fw25_admin.vue?vue&type=style&index=0&id=76653841&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76653841"]])

export default __exports__